export class UserHiddenTaskDisplayGroup {
  public task_display_group_id: number;

	constructor(task_display_group_id: number) {
		this.task_display_group_id = task_display_group_id
	}
}